<template>
  <vs-popup class="raw-material-stock-popup" title="RAW MATERIAL STOCK" @close="onClickClose()" :active.sync="open"
    :buttons-hidden="true">
    <vx-card no-shadow>
      <div id="raw-material-stock-popup" class="vx-row">
        <div class="vx-col lg:w-full w-full">
          <vs-table noDataText="">
            <template>
              <vs-tr>
                <vs-td class="font-semibold" width="70%">ITS PROD CODE</vs-td>
                <vs-td>{{ its_prod_code }}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">ITS PROD NAME</vs-td>
                <vs-td>{{ createForm.raw_material_name }}</vs-td>
              </vs-tr>

            </template>
          </vs-table>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col lg:w-full w-full">
          <vs-table noDataText="">
            <template>
              <vs-tr>
                <vs-td class="font-semibold" width="70%">TOTAL STOCK (KG)</vs-td>
                <vs-td colspan="2" class="text-lg font-bold text-primary">{{ toFixed(createForm.current_stock_level) }}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">AVAILABLE UNALLOCATED STOCK (KG)</vs-td>
                <vs-td colspan="2" class="text-lg font-bold text-primary">{{ toFixed(createForm.available_unallocated_stock)
                }}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">WO ALLOCATED STOCK (KG)</vs-td>
                <vs-td class="text-lg font-bold text-primary">{{
                  toFixed(createForm.confirmed_order_stock_allocation) }}
                </vs-td>
                <vs-td>
                    <vx-tooltip
                          text="View Allocated Work Orders" position="bottom">
                          <vs-button class="flex justify-end"
                            @click="onClickViewAllocatedWorkOrders()" size="small"
                            color="primary" type="border" icon-pack="feather" icon="icon-eye">View Allocated WO(s)</vs-button>
                        </vx-tooltip>
                  </vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">ON HOLD STOCK (KG)</vs-td>
                <vs-td colspan="2" class="text-lg font-bold text-primary">{{
                  toFixed(createForm.on_hold_stock) }}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">EXPIRED STOCK (KG) UNAVAILABLE FOR USE</vs-td>
                <vs-td colspan="2" class="text-lg font-bold text-primary">{{ toFixed(createForm.expired_stock) }}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">REJECT & SUSPENDED STOCK (KG)</vs-td>
                <vs-td colspan="2" class="text-lg font-bold text-primary">{{ toFixed(createForm.reject_suspended) }}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">LOW STOCK THRESHOLD (KG)</vs-td>
                <vs-td colspan="2" class="text-lg font-bold text-primary">{{ createForm.is_low_stock_threshold_required ? toFixed(createForm.low_stock_threshold) : 'Not set' }}</vs-td>
              </vs-tr>

            </template>
          </vs-table>
        </div>
      </div>

      <div v-if="createForm.last_purchase" class="vx-row mt-4">
        <div class="vx-col w-full">
          <div class="p-4 rounded" style="border: 2px solid #262c49">
            <p class="text-xs font-semibold text-grey mb-3">LAST PURCHASE</p>
            <div class="flex justify-between">
              <div>
                <small class="text-grey block mb-1">PO Code</small>
                <hyper-link :id="createForm.last_purchase.purchase_order_id" type="raw-material-order" class="font-semibold text-lg">{{ createForm.last_purchase.purchase_order_code }}</hyper-link>
              </div>
              <div>
                <small class="text-grey block mb-1">Supplier</small>
                <hyper-link :id="createForm.last_purchase.supplier_id" type="supplier" class="font-semibold text-lg">{{ createForm.last_purchase.supplier_name }}</hyper-link>
              </div>
              <div>
                <small class="text-grey block mb-1">Price per KG</small>
                <span class="font-semibold text-lg">{{ createForm.last_purchase.currency | currency_code_formatter }} {{ createForm.last_purchase.price_per_kg }}</span>
              </div>
              <div>
                <small class="text-grey block mb-1">PO Date</small>
                <span class="font-semibold text-lg">{{ createForm.last_purchase.order_date }}</span>
              </div>
              <div>
                <small class="text-grey block mb-1">PO Status</small>
                <vs-chip style="border-radius: 0" transparent :color="rmOrderStatusColor(createForm.last_purchase.item_status)">
                  {{ createForm.last_purchase.item_status }}
                </vs-chip>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-row mt-8">
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">View By RM Stock Status</label>
              <v-select :clearable="true" placeholder="" v-model="filters['status']" label="key" :reduce="option => option.value"
                :options="[ {key: 'In Stock', value: 'In_Stock'}, { key: 'Out of Stock', value: 'Out_of_Stock' }, { key: 'Expired', value: 'Expired' }, { key: 'On Hold', value: 'On Hold' }]" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Manufacturing Date From</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['manufacture-from']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['manufacture-from']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Manufacturing Date To</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['manufacture-to']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['manufacture-to']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Expiry Date From</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['expiry-to']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['expiry-to']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Expiry Date To</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['expiry-to']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['expiry-to']"
                placeholder="Choose Date"
              />
            </div>
        </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card no-shadow class="pt-2">
            <div slot="no-body">
              <!-- <vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="filters['search']"
                class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" /> -->
              <vs-table id="sundry-item-list-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="items" sort
                :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

                <template slot="thead">
                  <vs-th width="15%" class="text-sm">BATCH NO</vs-th>
                  <vs-th width="10%" class="text-sm" sort-key="sundry_item_code">ITS PRODUCT CODE</vs-th>
                  <vs-th width="10%" class="text-sm" sort-key="sundry_product_code">ITS PRODUCT NAME</vs-th>
                  <vs-th width="5%" class="text-sm">SUPPLIER BATCH NUMBER</vs-th>
                  <vs-th width="10%" class="text-sm">SHELF LOCATION</vs-th>
                  <vs-th width="10%" class="text-sm">MANUFACTURE DATE</vs-th>
                  <vs-th width="10%" class="text-sm">EXPIRATION DATE</vs-th>
                  <vs-th width="10%" class="text-sm">QUANTITY (KG)</vs-th>
                  <vs-th width="10%" class="text-sm">STOCK STATUS</vs-th>
                  <vs-th width="10%" class="text-sm">ACTION</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr @click.native="onClickUpdateRmStock(data[indextr])" class="text-sm" style="cursor: pointer"
                    :key="indextr" v-for="(tr, indextr) in data">


                    <vs-td :data="data[indextr].batch_no">
                      {{ data[indextr].batch_no }}
                    </vs-td>

                    <vs-td class="text-primary font-semibold" :data="data[indextr].company_product_code">
                      {{ data[indextr].category }}-{{ data[indextr].company_product_code }}
                    </vs-td>

                    <vs-td :data="data[indextr].company_product_name">
                      {{ data[indextr].company_product_name }}
                    </vs-td>

                    <vs-td :data="data[indextr].supplier_batch_no">
                      {{ data[indextr].supplier_batch_no }}
                    </vs-td>

                    <vs-td>
                      R {{ data[indextr].shelf_location_r || '-' }} | S {{ data[indextr].shelf_location_s || '-' }} | L {{
                        data[indextr].shelf_location_l || '-' }}
                    </vs-td>


                    <vs-td :data="data[indextr].manufacture_date">
                      {{ data[indextr].manufacture_date }}
                    </vs-td>

                    <vs-td :data="data[indextr].expiration_date">
                      {{ data[indextr].expiration_date }}
                    </vs-td>

                    <vs-td :data="data[indextr].available_quantity">
                      {{ Number(data[indextr].available_quantity).toFixed(4) }}
                    </vs-td>

                    <vs-td :data="data[indextr].status">
                      <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                        {{ data[indextr].status | stock_status_format }} <span class="text-danger ml-2 font-bold text-lg">{{ generateSuspendStatus(data[indextr].raw_material_status)  }}</span>
                      </vs-chip>
                    </vs-td>


                    <vs-td>
                      <div class="vx-row">
                        <vx-tooltip class="mr-2" text="Update rm stock" position="bottom">
                          <vs-button class="ml-3" @click.stop="onClickUpdateRmStock(data[indextr])" size="small"
                            color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-if="data[indextr].status === 'On Hold'" v-can="'create-edit-raw-material-orders-qc-test'" class="flex justify-start mr-2"
                          text="Return to available stock" position="bottom">
                          <vs-button class="flex justify-end"
                            @click.stop="onClickReturnToStock(data[indextr])" size="small"
                            color="danger" type="border" icon-pack="feather" icon="icon-rotate-cw"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-can="'create-edit-raw-material-orders-qc-test'" class="flex justify-start mr-2"
                          text="View QC Test" position="bottom" v-if="data[indextr].q_c_test">
                          <vs-button class="flex justify-end"
                            @click.stop="onClickUpdateQcTest(data[indextr].q_c_test.id, data[indextr].rm_id)" size="small"
                            color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                        </vx-tooltip>
                      </div>
                    </vs-td>

                  </vs-tr>
                </template>


              </vs-table>

              <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
                :max-items="perPage" description-body="Rows per page" description-connector="of"
                description-title="Records" description :description-items="descriptionItems"
                :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
              </vs-pagination>


            </div>
          </vx-card>
        </div>
      </div>

    </vx-card>
    <update-rm-stock-pop-up v-on:refreshData="refreshData" ref="UpdateRmStockPopUp" />
    <update-qc-test-rm-order-item-pop-up ref="updateQcTestRmOrderItemPopUp" />
    <RmWasteSendBackToStockPopUp ref="rmWasteSendBackToStockPopUp" v-on:refreshData="refreshData"/>
    <RmAllocatedWorkOrdersPopUp ref="rmAllocatedWorkOrdersPopUp" v-on:refreshData="refreshData"/>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const InventoryRepository = RepositoryFactory.get('inventory')
const ManufacturingRepository = RepositoryFactory.get('manufacturing')

import UpdateRmStockPopUp from "@/components/popups/manufacturing/raw-material-stock/UpdateRmStockPopUp";
import UpdateQcTestRmOrderItemPopUp from "@/components/popups/inventory/rm-orders/qc-tests/UpdateQcTestRmOrderItemPopUp";

import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Filter from '@/mixins/filter';
import { defaultPagination, perPageList } from "@/constants/config";
import { raw_material_order_statuses } from '@/constants/statuses';
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import RmWasteSendBackToStockPopUp from '@/components/popups/inventory/stock/RmWasteSendBackToStockPopUp.vue';
import RmAllocatedWorkOrdersPopUp from '@/components/popups/inventory/stock/RmAllocatedWorkOrdersPopUp.vue';
import HyperLink from '@/components/Hyperlink/HyperLink';

function initialState() {
  return {
    open: false,
    id: '',
    items: [],
    filters: {},
    page: 1,
    total: 0,
    meta: {},
    sort: '',
    perPage: defaultPagination,
    descriptionItems: perPageList,
    its_prod_code: '',
    createForm: {},
  }
}

export default {
  name: 'ViewRawMaterialStockPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.open = true;
        await this.fetchRmStockList()
      } catch (error) {

      }
    },
    closePopup() {
      this.open = false
    },
    async refreshData() {
      await this.fetchRmStockList()
    },
    async fetchRmStockList() {
      await this.$vs.loading({
        container: '#raw-material-stock-popup',
        scale: 0.45
      })
      try {
        const { data } = (await InventoryRepository.getRawMaterialStock(this.id)).data
        this.createForm = data
        this.its_prod_code = this.createForm.raw_material_category + '-' + this.createForm.raw_material_code
        this.fetchRmStockInventory()
      } catch (e) {

      }
      this.$vs.loading.close('#raw-material-stock-popup > .con-vs-loading')
    },
    async fetchRmStockInventory() {
      await this.$vs.loading({
        container: '#raw-material-stock-popup',
        scale: 0.45
      })
      try {
        const { data } = await ManufacturingRepository.getRawMaterialStock(this.page, `filter[search]=${this.its_prod_code}&${this.filterQuery}`, this.perPage, '')
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.showWarningMessage('Something went wrong. Please try again!')
      }
      this.$vs.loading.close('#raw-material-stock-popup > .con-vs-loading')
    },
    onClickUpdateRmStock(data) {
      this.$refs.UpdateRmStockPopUp.openPopup(data.id)
    },
    async onClickUpdateQcTest(test_id, rm_id) {
      await this.$refs.updateQcTestRmOrderItemPopUp.openPopup(test_id, rm_id)
    },
    async onClickReturnToStock(data) {
      this.$refs.rmWasteSendBackToStockPopUp.openPopup(data)
    },
    filterQueryUpdate() {
      this.fetchRmStockInventory()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchRmStockInventory()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchRmStockInventory()
      }

    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    toFixed(number) {
      return Math.floor(number * 10000) / 10000
      // return Number(number).toFixed(4)
    },
    onClickClose() {
      this.open = false
    },
    generateSuspendStatus(status) {
      if(status.includes('Suspended')) {
        return `S${status.charAt(status.length - 1)}`
      }
    },
    async onClickViewAllocatedWorkOrders() {
      this.$refs.rmAllocatedWorkOrdersPopUp.openPopup(this.createForm.id)
    },
    rmOrderStatusColor(statusName) {
      const match = raw_material_order_statuses.find(s => s.name === statusName)
      return match ? match.color : 'warning'
    },
  },

  components: {
    'v-select': vSelect,
    UpdateRmStockPopUp,
    UpdateQcTestRmOrderItemPopUp,
    flatPickr,
    RmWasteSendBackToStockPopUp,
    RmAllocatedWorkOrdersPopUp,
    HyperLink
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
  watch: {
    page() {
      this.fetchRmStockInventory()
    },
    perPage() {
      this.fetchRmStockInventory()
    },
  }
}
</script>

<style scoped>
.raw-material-stock-popup>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 70% !important;
}
</style>
